import React from 'react';

import classnames from 'classnames/bind';
import styles from './AccountInfoCard.module.scss';
import { Typography } from 'gd-design-library';

const CN = 'account-info';
const cardClassName = `${CN}__card`;
const titleClassName = `${CN}__title`;
const mobileTitleClassName = `${titleClassName}--mobile`;
const desktopTitleClassName = `${titleClassName}--desktop`;
const contentClassName = `${CN}__content`;
const actionClassName = `${CN}__action`;
const editActionClassName = `${actionClassName}--edit`;

const cx = classnames.bind(styles);

interface AccountInfoCardProps {
  onEdit?: () => void;
  title: string;
  children: React.ReactNode;
}

export const AccountInfoCard: React.FC<AccountInfoCardProps> = ({ children, onEdit, title }) => (
  <div className={ cx(CN) }>
    <Typography variant='h6' className={ cx(desktopTitleClassName) }>{ title }</Typography>
    <Typography variant='h5' className={ cx(mobileTitleClassName) }>{ title }</Typography>
    <div className={ cx(cardClassName) }>
      <div className={ cx(contentClassName) }>
        { children }
      </div>
      <Typography
        onClick={ onEdit }
        className={ cx(editActionClassName) }
        role='button'
      >
        Edit
      </Typography>
    </div>
  </div>

);
